import SEO from './SEO';
import Footer from './Footer';
import Header from './Header';
import Title from './Title';
import Layout from './Layout';
import Wrapper from './Wrapper';

export { Footer, Layout, SEO, Wrapper, Title, Header };
